import { NavLink, useSearchParams } from "react-router-dom";

export default function SuccessPage() {
  const [searchParams] = useSearchParams();
  const formId = searchParams.get("form-id");

  return (
    <div className="mx-auto flex min-h-[70vh] w-full max-w-lg items-center px-4 py-12 sm:px-6">
      <div className="w-full rounded-2xl border border-slate-200/80 bg-white p-8 text-center shadow-card-lg sm:p-10">
        <div
          className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-brand-50"
          aria-hidden
        >
          <svg
            className="h-7 w-7 text-brand-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h1 className="font-unbounded text-2xl font-bold leading-tight text-ink">
          Спасибо!
        </h1>
        <p className="mt-2 font-onest text-base text-ink-muted">
          Ваше сообщение отправлено.
        </p>
        {formId ? (
          <NavLink
            to={`/forms/${formId}`}
            className="mt-8 inline-flex w-full items-center justify-center rounded-xl bg-brand-500 px-6 py-3 font-onest text-[15px] font-medium text-white shadow-md shadow-brand-500/25 transition-colors hover:bg-brand-600 sm:w-auto"
          >
            Заполнить форму ещё раз
          </NavLink>
        ) : null}
      </div>
    </div>
  );
}
